import { MotifButton } from "@ey-xd/motif-react"
import CustomModal from "components/ReportGenerator/Preview/CustomModal";
import { useSelector } from "react-redux";
import { MotifErrorMessage } from "@ey-xd/motif-react";

import "./PrivacyPolicyModal.scss";

interface PrivacyPolicyModalProps {
    onAcceptPolicy: () => void;
}

const PrivacyPolicyModal = ({ onAcceptPolicy }: PrivacyPolicyModalProps) => {    
    const {
        fileUrl,
        errorMessage
    } = useSelector((state: any) => state?.paansIntegration);

    return (
        <CustomModal show={true} showfooter={false}>
            <div className="privacy-policy-modal-header">
                <h3>Read and accept the privacy policy</h3>
            </div>
            <div className="privacy-policy-modal-body">
                <div className="privacy-policy-modal-content">
                    <iframe
                        src={fileUrl}
                        title="Privacy Policy"
                        width="100%"
                        height="400px"
                    />
                </div>
                {errorMessage && <MotifErrorMessage role='alert'> {errorMessage} </MotifErrorMessage>}
            </div>
            <div
                className="privacy-policy-modal-footer"
            >
                <MotifButton
                    onClick={onAcceptPolicy}
                    size="small"
                    type="button"
                >
                    Accept
                </MotifButton>
            </div>
        </CustomModal>
    )
}

export default PrivacyPolicyModal;